import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { CategoryStoreGroupPayload } from "@/types/interface/category-store-group";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useDepartmentStore } from "@/stores/master/department";
import { usePositionStore } from "@/stores/master/position";
import { mapOptionMultiselect } from "@/utils/helper";
import { useCategoryStore } from "@/stores/master/category-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCategoryStoreGroup',
  setup(__props) {

const idCategoryStoreGroup = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const categoryStoreGroup = useCategoryGroupStore();
const departmentStore = useDepartmentStore();
const categoryStore = useCategoryStore();
const positionStore = usePositionStore();

const listDepartment = ref<any>();
const listCategory = ref<any>();
const listPosition = ref<any>();
const detailCategoryStoreGroup = ref<any>();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Category Store Name is required" }),
    category_code: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.string()
    ),
    department_code: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.string()
    ),
    pic: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: category_code } = useField<number>("category_code");
const { value: department_code } = useField<number>("department_code");
const { value: pic } = useField<number>("pic");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadCategoryStoreGroup: CategoryStoreGroupPayload = {
    name: name.value,
    category_code: category_code.value?.value,
    department_code: department_code.value?.value,
    pic: pic.value?.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await categoryStoreGroup.dispatchUpdate(
      idCategoryStoreGroup.value,
      payloadCategoryStoreGroup
    );
  } else {
    responseApi.value = await categoryStoreGroup.dispatchCreate(
      payloadCategoryStoreGroup
    );
  }
  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Category Group Store Successfully Updated"
          : "Category Group Store Successfully Added"
      );
      router.push("/master/category-store-group");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadListDepartment = async () => {
  const { success, message } = await departmentStore.dispatchGetDepartments();
  if (success) {
    listDepartment.value = mapOptionMultiselect(
      await departmentStore?.departments?.items,
      "code",
      "name"
    );
  }
};

const loadListCategory = async () => {
  const { success, message } = await categoryStore.dispatchGetCategories();
  if (success) {
    listCategory.value = mapOptionMultiselect(
      await categoryStore.categories.items,
      "code",
      "name"
    );
  }
};

const loadListPosition = async () => {
  const { success, message } = await positionStore.dispatchGetPositions(1,10,'&is_pagination=false');
  if (success) {
    listPosition.value = mapOptionMultiselect(
      await positionStore.positions.items,
      "id",
      "name"
    );
  }
};

const loadDetailCategoryStoreGroup = async () => {
  const { success, message } = await categoryStoreGroup.dispatchDetail(
    idCategoryStoreGroup.value
  );
  if (success) {
    detailCategoryStoreGroup.value = await categoryStoreGroup.categoryGroup
      .data;
    name.value = detailCategoryStoreGroup.value.name;
    category_code.value = mapOptionMultiselect(
      detailCategoryStoreGroup.value.category,
      "code",
      "name"
    );
    department_code.value = mapOptionMultiselect(
      detailCategoryStoreGroup.value.department,
      "code",
      "name"
    );
  }
};

loadListDepartment();
loadListCategory();
loadListPosition();

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idCategoryStoreGroup.value = router.currentRoute.value.params.id.toString();
    loadDetailCategoryStoreGroup();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Category Store Group"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/category-store-group"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Category Store Group ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "category_code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Category Store Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(category_code),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(category_code) ? (category_code).value = $event : null)),
                          options: listCategory.value,
                          placeholder: "Choose Category Store"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).category_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "department_code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Department "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(department_code),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(department_code) ? (department_code).value = $event : null)),
                          options: listDepartment.value,
                          placeholder: "Choose Department"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).department_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "position_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Person in Charge "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(pic),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(pic) ? (pic).value = $event : null)),
                          options: listPosition.value,
                          placeholder: "Choose Person in Charge"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).pic), 1)
                    ])
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})